module.exports = __webpack_public_path__ + "img/tercera.a5b91cc5.jpg";